module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_03-3511a399ab1953584e1a98c221834417.jpg";